'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdNotificationsOff = function MdNotificationsOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 24.5l-14.9-15.7c0.4-0.2 0.8-0.4 1.2-0.6h0l0.5-0.2c0.2-0.1 0.5-0.1 0.7-0.2v-1.2c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v1.2c4.8 1.2 7.5 5.4 7.5 10.6v6.1z m-10 12.1c-1.9 0-3.4-1.4-3.4-3.2h6.8c0 1.8-1.5 3.2-3.4 3.2z m-7-26.4c7.4 7.6 14.7 15.1 22 22.7l-2.1 2.1-3.4-3.4h-22.9v-1.6l3.4-3.4v-8.3c0-2.1 0.5-4.1 1.3-5.7l-4.7-4.6 2.2-2.2z' })
        )
    );
};

exports.default = MdNotificationsOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/notifications-off.js
// module id = 3113
// module chunks = 0